import styled from 'styled-components';

import { fontSizes, colors } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';
import { pxToRem } from 'utils/convert';

import { AssociatedEntity } from '../../../../../domain';
import { AGGREGATE_ENTITIES, ENTITIES } from '../../../constants';
import { UserEventDisplay } from './UserEventDisplay';

interface MultipleEventsDisplayProps {
  events: AssociatedEntity[];
  entityType: ENTITIES;
}

const StyledTotalEventsDisplay = styled.div`
  display: flex;
  gap: ${pxToRem(4)};
  font-size: ${fontSizes.s12};
  color: ${colors.textSecondary};
`;

const displayText = {
  showTotal: 'Show all',
};

const TooltipContent = ({ events }: { events: AssociatedEntity[] }) => (
  <div>
    {events.map((event) => (
      <div key={event.id}>
        {`• ${event.name} ( ${event.id} )`} <br />
      </div>
    ))}
  </div>
);

export const MultipleEventsDisplay = ({ events, entityType }: MultipleEventsDisplayProps) => {
  const total = events.length;
  return (
    <div data-test="event-history-multiple-events">
      <UserEventDisplay id={events[0].id} name={events[0].name} />
      <UserEventDisplay id={events[1].id} name={events[1].name} />
      <StyledTotalEventsDisplay data-test="total-event-display">
        {displayText.showTotal}
        <Tooltip isUnderlined tooltipContent={<TooltipContent events={events} />}>
          {`${total} ${AGGREGATE_ENTITIES[entityType]}`}
        </Tooltip>
      </StyledTotalEventsDisplay>
    </div>
  );
};
